import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange, Injector } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Subject } from 'rxjs/Subject';

// Lib imports.
///////////////

// Services.
import { LoggerService, LogLevel, WaHelperService, ViewDataConfigStruct } from 'world-archery-lib';

// Interfaces.
import { LocatorInterface } from 'world-archery-lib'
import { ViewDataInterface } from 'world-archery-lib'

// Classes.
import { LoggedComponent } from 'world-archery-lib'
import { EventListLocator } from 'world-archery-lib'
import { EventGeneralInfoItem } from 'world-archery-lib';
import { ViewDataService } from 'world-archery-lib';
import { of, forkJoin, BehaviorSubject } from 'rxjs';
import { mergeMap, map, flatMap, tap, filter, combineLatest, take, merge, concat, distinctUntilChanged } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EventsResultsFiltersService } from '../../services/events-results-filters.service';
import { TableAbstractComponent } from 'src/app/common-page-components/classes/table-abstract-component';
import { EventsStore } from 'src/app/common-page-components/stores/entities-store/events-store';

@Component({
  selector: 'event-list-view',
  templateUrl: './event-list-view.component.html',
  styleUrls: ['./event-list-view.component.scss'],
  inputs: ['search', 'from', 'to', 'level', 'sort', 'sortAsc']
})
export class EventListViewComponent extends TableAbstractComponent {

  /**
   *
   * Expected model of page to do changes
   * @type {*}
   * @memberof EventListViewComponent
   */
  expected_model: any = { loading: true };

  /**
   *
   * Refresh subject for load more data
   * @protected
   * @memberof EventListViewComponent
   */
  protected refreshSubject = new BehaviorSubject(true);

  // tslint:disable-next-line:max-line-length
  constructor(injector: Injector, http: HttpClient, public filter_service: EventsResultsFiltersService, protected waHelper: WaHelperService, ) {
    super(injector, filter_service, new EventsStore(http, waHelper, injector));
    this.expected_model.loading = true;
  }



  ngOnInit() {
    this.getDataStream().pipe(map(a => a)).subscribe()
    /*this.getDataStreamLive().pipe(map(a => a)).subscribe(next => {
      this.expected_model.itemsLive = next.map(value => new EventGeneralInfoItem(value, this.waHelper)).sort((a, b) =>
        a.dateFrom > b.dateFrom ? this.sortDate() : -this.sortDate());
      this.expected_model.loadingLive = false;
    });*/
  }




  /**
   *
   * Data stream of events connected to filter
   * @returns
   * @memberof EventListViewComponent
   */
  getDataStream() {
    return this.filter_service.getDataStreamWithFilters().pipe(
      combineLatest([this.reload.asObservable()]),
      map(([a, c]) => Object.assign(a, { number_items: c })),
      filter(a => a.level !== undefined),
      map(values => {
        if (values === undefined) {
          return of([]);
        }
        this.expected_model.loading = true;
        const params = {
          SortBy: values.sort.sortingSend,
          fText: values.text,
          WithResults: 1,
          LevelId: values.level ? values.level.map(value => value.toString() + '').join('|') : undefined,
          WorldRankingEvent: values.isWorldRanking
        }

        if (values.level == undefined) {
          values.level = [undefined as any];
        }
        return params;
      }
      ),
      mergeMap(params => this.model.requestData(params, this.request_more_data))
    );

  }

}
